import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import { GoBackButton, RedirectHomeButton } from '../../components/elements'

export interface AuthenticateProgressProps {
  message: string
  subMessage?: string
  returnToHomeButton?: boolean
  returnToBefore?: boolean
}

export function AuthenticateProgress(props: AuthenticateProgressProps) {
  return (
    <Dialog closeIcon={false}>
      <strong>{props.message}</strong>
      {props.subMessage != null &&
        <div>{props.subMessage}</div>}
        {(props.returnToHomeButton === true || props.returnToBefore === true) && (
          <DialogActionsBar>
            {(props.returnToHomeButton ?? false) && <RedirectHomeButton themeColor='primary'>もう一度やり直す</RedirectHomeButton>}
            {(props.returnToBefore ?? false) && <GoBackButton themeColor='primary'>戻る</GoBackButton>}
          </DialogActionsBar>
        )}
    </Dialog>
  )
}
